import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LearningRoutingModule } from './learning-routing.module';
import { AdminModule } from '../admin/admin.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BsDatepickerModule, TimepickerModule } from 'ngx-bootstrap';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { LearningBookTitleComponent } from './learning-book-title/learning-book-title.component';
import { ChapterHeadingComponent } from './chapter-heading/chapter-heading.component';
import { ChapterTopicComponent } from './chapter-topic/chapter-topic.component';
import { ChapterContentComponent } from './chapter-content/chapter-content.component';
import { TeachingComponent } from './teaching/teaching.component';
import { NgxEditorModule } from 'ngx-editor';
import { TutorialComponent } from './tutorial/tutorial.component';
import { ClassBookTitleMapComponent } from './class-book-title-map/class-book-title-map.component';
import { WorkSheetComponent } from './work-sheet/work-sheet.component';
import { QuestionBankComponent } from './question-bank/question-bank.component';

import { OnlineexamComponent } from './onlineexam/onlineexam.component';
import { OnlineteachingComponent } from './onlineteaching/onlineteaching.component';
import { OnlinetutorialComponent } from './onlinetutorial/onlinetutorial.component';
import { TestReportComponent } from './test-report/test-report.component';
import { StudentTestPrintComponent } from './student-test-print/student-test-print.component';
import { StaffTestPrintComponent } from './staff-test-print/staff-test-print.component';
import { LiveClassComponent } from './live-class/live-class.component';
import { StudentTestReportPrintComponent } from './student-test-report-print/student-test-report-print.component';
import { TestReportPrintComponent } from './test-report-print/test-report-print.component';
import { LecturePlanComponent } from './lecture-plan/lecture-plan.component';
import { StudentliveclassComponent } from './studentliveclass/studentliveclass.component';



@NgModule({
  declarations: [LearningBookTitleComponent,ChapterHeadingComponent,ChapterTopicComponent,
    ChapterContentComponent,TeachingComponent,TutorialComponent,ClassBookTitleMapComponent,

    WorkSheetComponent,QuestionBankComponent, OnlineexamComponent, OnlineteachingComponent, OnlinetutorialComponent,TestReportComponent, StudentTestPrintComponent, StaffTestPrintComponent, LiveClassComponent, StudentTestReportPrintComponent, TestReportPrintComponent, LecturePlanComponent, StudentliveclassComponent],

    

    

  imports: [
    CommonModule,
    LearningRoutingModule,
    AdminModule,
    FormsModule,
    ReactiveFormsModule,
    BsDatepickerModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
    NgxEditorModule,
    TimepickerModule.forRoot()
  ]
})
export class LearningModule { }
